export default "__VITE_ASSET__D3rMOruR__"